import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { Web5Provider } from '@web/web5';
import Signup from './components/Signup';
import { DEFAULT_THEME } from './theme';

function init(el, lang, referral) {
    if (!el) throw new Error('No elemento provided for Signup Form init');
    const root = ReactDOM.createRoot(el);
    root.render(
        <React.StrictMode>
            <Web5Provider theme={DEFAULT_THEME}>
                <Signup lang={lang} referral={referral} />
            </Web5Provider>
        </React.StrictMode>,
    );
}

window.SignupInit = init;

if (process.env.NODE_ENV === 'development') {
    init(document.getElementById('root'), 'es');
}
